import React from 'react';
import { clsx } from '@mentimeter/ragnar-tailwind-config';
import { Text, type TextT } from '../text/tw';
import { variants } from './typography.variants';

export const Heading = ({ className, ...rest }: TextT) => {
  const classes = variants({ variant: 'heading' });

  return <Text className={clsx(classes, className)} {...rest} />;
};

export const SubHeading = ({ className, ...rest }: TextT) => {
  const classes = variants({ variant: 'subheading' });

  return <Text className={clsx(classes, className)} {...rest} />;
};

export const P = ({ className, ...rest }: TextT) => {
  const classes = variants({ variant: 'paragraph' });

  return <Text as="p" className={clsx(classes, className)} {...rest} />;
};

export const Strong = ({ className, ...rest }: TextT) => {
  const classes = variants({ variant: 'strong' });

  return <Text className={clsx(classes, className)} {...rest} />;
};

export const Meta = ({ className, ...rest }: TextT) => {
  const classes = variants({ variant: 'meta' });

  return <Text className={clsx(classes, className)} {...rest} />;
};
